import Operations from '@/components/operations.vue';
import OrganisationForm from '@/components/organisation_form.vue';
import ConfigurationMineForm from '@/components/organisations/configuration/configuration_mine_form.vue';
import ConfigurationProcessForm from '@/components/organisations/configuration/configuration_process_form.vue';
import ConfigurationTypeForm from '@/components/organisations/configuration/configuration_type_form.vue';
import Configurations from '@/components/organisations/configuration/configuration_page.vue';
import Plants from '@/components/plants.vue';
import Shafts from '@/components/shafts.vue';
import ShaftsV2 from '@/components/shafts_v2.vue';
import Ships from '@/components/ships.vue';
import EquipmentList from '@/components/equipment.vue';

export default [
  {
    path: '/',
    name: 'root',
    component: Operations,
    props: true,
  },
  {
    path: '/organisations/new',
    name: 'newOrganisation',
    component: OrganisationForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId',
    name: 'organisationConfiguration',
    component: Configurations,
    props: true,
    children: [
      {
        path: 'edit',
        name: 'editOrganisationConfiguration',
        component: Configurations,
        props: true,
      },
      {
        path: 'mines',
        name: 'mineConfiguration',
        component: Configurations,
        props: true,
      },
      {
        path: 'equipment/processes',
        name: 'equipmentProcessConfiguration',
        component: Configurations,
        props: true,
      },
      {
        path: 'equipment/types',
        name: 'equipmentTypeConfiguration',
        component: Configurations,
        props: true,
      },
      {
        path: 'operations/types',
        name: 'operationTypeConfiguration',
        component: Configurations,
        props: true,
      }
    ],
  },
  {
    path: '/organisations/:organisationId/mines/new',
    name: 'newMineForm',
    component: ConfigurationMineForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/mines/:mineId',
    name: 'mineForm',
    component: ConfigurationMineForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/equipment/processes/new',
    name: 'newEquipmentProcessForm',
    component: ConfigurationProcessForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/equipment/processes/:processId',
    name: 'equipmentProcessForm',
    component: ConfigurationProcessForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/equipment/types/new',
    name: 'newEquipmentTypeForm',
    component: ConfigurationTypeForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/equipment/types/:typeId',
    name: 'equipmentTypeForm',
    component: ConfigurationTypeForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/operations/types/new',
    name: 'newOperationTypeForm',
    component: ConfigurationTypeForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId/operations/types/:typeId',
    name: 'operationTypeForm',
    component: ConfigurationTypeForm,
    props: true,
  },
  {
    path: '/organisations/:organisationId',
    name: 'operations',
    component: Operations,
    props: true,

    children: [
      {
        path: 'operations',
        name: 'plants',
        component: Plants,
        props: true,
      },
      {
        path: 'shafts',
        name: 'shafts',
        component: Shafts,
        props: true,
      },
      {
        path: 'shafts_v2',
        name: 'shafts_v2',
        component: ShaftsV2,
        props: true,
      },
      {
        path: 'ships',
        name: 'ships',
        component: Ships,
        props: true,
      },
      {
        path: 'equipment',
        name: 'equipmentList',
        component: EquipmentList,
        props: true,
      },
    ],
  },
];
